import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import { CRON_SPECIAL } from '../constants'
import CustomCronBuilder from './CustomCronBuilder'

const CUSTOM_OPTION = { label: 'Personnalisé', value: CRON_SPECIAL.CUSTOM }

const RecurrenceField = ({
  cronExpression, recurrenceOptions, showCustomCron, error,
  onFieldChange, onToggleCustom
}) => {
  const presetMatch = recurrenceOptions.find(option => option.value === cronExpression)
  const selectedRecurrence = showCustomCron ? CUSTOM_OPTION : presetMatch || CUSTOM_OPTION
  const presetDescription = presetMatch?.description

  const handleRecurrenceChange = useCallback(option => {
    onToggleCustom(option.value === CRON_SPECIAL.CUSTOM)
    onFieldChange('cronExpression', option.value)
  }, [onFieldChange, onToggleCustom])

  const handleCustomCronChange = useCallback(cron => {
    onFieldChange('cronExpression', cron)
  }, [onFieldChange])

  return (
    <>
      <div className="form-group">
        <label>Récurrence</label>
        <Select
          options={recurrenceOptions}
          value={selectedRecurrence}
          error={Boolean(error)}
          onChange={handleRecurrenceChange}
        />
        {error ?<small className="text-danger">{error[0]}</small>: null}
        {presetDescription && !showCustomCron ? (
          <p className="text-info-blue mb-0 mt-1">
            <i className="fas fa-check-circle mr-1" />
            <small className="font-weight-semibold">{presetDescription}</small>
          </p>
        ) : null}
      </div>
      {showCustomCron ? (
        <CustomCronBuilder
          initialCron={cronExpression}
          onChange={handleCustomCronChange}
        />
      ) : null}
    </>
  )
}

RecurrenceField.propTypes = {
  cronExpression: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.string),
  onFieldChange: PropTypes.func.isRequired,
  onToggleCustom: PropTypes.func.isRequired,
  recurrenceOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    description: PropTypes.string
  })).isRequired,
  showCustomCron: PropTypes.bool.isRequired
}

RecurrenceField.defaultProps = {
  cronExpression: null,
  error: null
}

export default RecurrenceField
